import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'lib-inline-loading-shimmer',
  imports: [],
  templateUrl: './inline-loading-shimmer.component.html',
  styleUrl: './inline-loading-shimmer.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InlineLoadingShimmerComponent {
  showLoading = input<boolean>(true);
}
